import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import SemaphoreManager from './SemaphoreManager';

type SemaphoreDialogProps = {
  open: boolean;
  onClose: () => void;
};

const SemaphoreDialog: FC<SemaphoreDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Semaphores</DialogTitle>
      <DialogContent>
        <SemaphoreManager />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color='primary'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SemaphoreDialog;
